import { render, staticRenderFns } from "./UpdateReceptionMaterial.vue?vue&type=template&id=58680f90"
import script from "./UpdateReceptionMaterial.vue?vue&type=script&lang=js"
export * from "./UpdateReceptionMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports